import * as _ from 'lodash';

import { hyphenToFowardSlash } from './stringUtil';
import { getLevelWorkerName } from './workerUtil';

/**
 * 各オブジェクトセルには、テーブルでのセルのテキストと属性スタイルが含まれている
 * @param {any} value 表示されるテキスト値
 * @param {Number} type セルのタイプ
 * @param {Number} width 列の長さ、SUB_HEADING形式でのセルにのみ定義するべき
 * @param {Boolean} isError テーブルのセルにエラーがあるかどうかを判別し DATA形式でのセルにのみ適用される
 * @param {Boolean} isRequired 列が必須であることを確定し SUB_HEADINGセルにのみ適用される
 */
export class Cell {
  static BLANK = 1;
  static MAIN_HEADING = 2;
  static SUB_HEADING = 3;
  static DATA = 4;
  static DEFAULT_WIDTH = 200;
  constructor({
    value,
    type = Cell.DATA,
    required,
    isError,
    width = Cell.DEFAULT_WIDTH,
  }) {
    this.value = value;
    this.type = type;
    this.width = width;
    this.isError = isError;
    this.required = required;
  }
}

const renderMainHeader = isFileError => {
  const result = [];
  result.push(new Cell({ value: '1.基本情報', type: Cell.MAIN_HEADING }));
  _.times(isFileError ? 8 : 7, () => {
    result.push(new Cell({ type: Cell.BLANK }));
  });
  result.push(
    new Cell({ value: '2.労務安全基本情報', type: Cell.MAIN_HEADING })
  );
  _.times(20, () => {
    result.push(new Cell({ type: Cell.BLANK }));
  });
  return result;
};

const renderSubHeadings = (isFileError = false) => {
  const result = [];
  isFileError &&
    result.push(
      new Cell({ value: 'エラー状況', type: Cell.SUB_HEADING, width: 102 })
    );
  result.push(new Cell({ value: '新規／更新', type: Cell.SUB_HEADING }));
  result.push(
    new Cell({ value: '姓', type: Cell.SUB_HEADING, required: true })
  );
  result.push(
    new Cell({ value: '名', type: Cell.SUB_HEADING, required: true })
  );
  result.push(
    new Cell({ value: 'セイ', type: Cell.SUB_HEADING, required: true })
  );
  result.push(
    new Cell({ value: 'メイ', type: Cell.SUB_HEADING, required: true })
  );
  result.push(
    new Cell({ value: '性別', type: Cell.SUB_HEADING, required: true })
  );
  result.push(
    new Cell({ value: '生年月日', type: Cell.SUB_HEADING, required: true })
  );
  result.push(new Cell({ value: '技能レベル', type: Cell.SUB_HEADING }));
  result.push(new Cell({ value: 'ABO血液型', type: Cell.SUB_HEADING }));
  result.push(new Cell({ value: 'Rh血液型', type: Cell.SUB_HEADING }));
  result.push(new Cell({ value: '国籍', type: Cell.SUB_HEADING }));
  result.push(new Cell({ value: '国名', type: Cell.SUB_HEADING }));
  result.push(new Cell({ value: '在留資格', type: Cell.SUB_HEADING }));
  result.push(new Cell({ value: '在留期間満了日', type: Cell.SUB_HEADING }));
  result.push(new Cell({ value: '経験開始年月日', type: Cell.SUB_HEADING }));
  result.push(
    new Cell({ value: 'ブランク期間（月）', type: Cell.SUB_HEADING })
  );
  result.push(
    new Cell({ value: '雇入時教育受講有無', type: Cell.SUB_HEADING })
  );
  result.push(new Cell({ value: '雇入時教育年月日', type: Cell.SUB_HEADING }));
  result.push(
    new Cell({ value: '能力向上教育受講有無', type: Cell.SUB_HEADING })
  );
  result.push(
    new Cell({
      value: '危険有害業務_再発防止教育受講有無',
      type: Cell.SUB_HEADING,
      width: 240,
    })
  );
  result.push(new Cell({ value: '雇入年月日', type: Cell.SUB_HEADING }));
  result.push(new Cell({ value: '郵便番号', type: Cell.SUB_HEADING }));
  result.push(new Cell({ value: '都道府県', type: Cell.SUB_HEADING }));
  result.push(new Cell({ value: '市区町村', type: Cell.SUB_HEADING }));
  result.push(new Cell({ value: '住所1', type: Cell.SUB_HEADING }));
  result.push(new Cell({ value: '住所2', type: Cell.SUB_HEADING }));
  result.push(new Cell({ value: '電話番号', type: Cell.SUB_HEADING }));
  result.push(new Cell({ value: 'FAX', type: Cell.SUB_HEADING }));
  result.push(new Cell({ value: 'メールアドレス', type: Cell.SUB_HEADING }));
  return result;
};

export const getGridData = (
  workerLists,
  isFileError = false,
  version,
  withHeader = false
) => {
  const result = [];

  if (_.isEmpty(workerLists)) {
    result.push(renderMainHeader(isFileError));
    result.push(renderSubHeadings(isFileError, []));
    return result;
  }
  if (withHeader) {
    result.push(renderMainHeader(isFileError));
    result.push(renderSubHeadings(isFileError, workerLists));
  }
  _.each(workerLists, item => {
    const data = [];

    isFileError &&
      item.line_status !== 'OK' &&
      data.push(
        new Cell({
          value: item.line_status === 'SKIP' ? 'スキップ' : 'エラーあり',
          isError: true,
        })
      );
    isFileError &&
      item.line_status === 'OK' &&
      data.push(
        new Cell({
          value: '',
        })
      );
    /*【1.基本情報】*/
    data.push(
      new Cell({
        value: item.update ? '更新' : '新規',
      })
    );
    data.push(
      new Cell({
        value: _.defaultTo(item.worker.name_sei, ''),
        isError: hasError(item.worker.error_columns, 'name_sei'),
      })
    );
    data.push(
      new Cell({
        value: _.defaultTo(item.worker.name_mei, ''),
        isError: hasError(item.worker.error_columns, 'name_mei'),
      })
    );
    data.push(
      new Cell({
        value: _.defaultTo(item.worker.name_sei_kana, ''),
        isError: hasError(item.worker.error_columns, 'name_sei_kana'),
      })
    );
    data.push(
      new Cell({
        value: _.defaultTo(item.worker.name_mei_kana, ''),
        isError: hasError(item.worker.error_columns, 'name_mei_kana'),
      })
    );
    data.push(
      new Cell({
        value: _.defaultTo(item.worker.sex_ja, ''),
        isError: hasError(item.worker.error_columns, 'sex_ja'),
      })
    );
    data.push(
      new Cell({
        value: hyphenToFowardSlash(_.defaultTo(item.worker.birthday, '')),
        isError: hasError(item.worker.error_columns, 'birthday'),
      })
    );
    data.push(
      new Cell({
        value: _.defaultTo(`${item.worker.rank_name_code_ja || ''}${item.worker.rank_card_color_code_ja || ''}`,
          ''
        ),
        isError:
          hasError(item.worker.error_columns, 'rank_name_code_ja') ||
          hasError(item.worker.error_columns, 'rank_card_color_code_ja'),
      })
    );
    /*【2.労務安全基本情報】*/
    data.push(
      new Cell({
        value: _.defaultTo(item.worker_detail.blood_type_ja, ''),
        isError: hasError(item.worker_detail.error_columns, 'blood_type_ja'),
      })
    );
    data.push(
      new Cell({
        value: _.defaultTo(item.worker_detail.blood_type_rh_ja, ''),
        isError: hasError(item.worker_detail.error_columns, 'blood_type_rh_ja'),
      })
    );
    data.push(
      new Cell({
        value: _.defaultTo(item.worker_detail.foreigner_flag_ja, ''),
        isError: hasError(
          item.worker_detail.error_columns,
          'foreigner_flag_ja'
        ),
      })
    );
    data.push(
      new Cell({
        value: _.defaultTo(item.worker_detail.nationality, ''),
        isError: hasError(item.worker_detail.error_columns, 'nationality'),
      })
    );
    data.push(
      new Cell({
        value: _.defaultTo(item.worker_detail.resident_status_name, ''),
        isError: hasError(
          item.worker_detail.error_columns,
          'resident_status_name'
        ),
      })
    );
    data.push(
      new Cell({
        value: hyphenToFowardSlash(
          _.defaultTo(item.worker_detail.staying_period_expiration_date, '')
        ),
        isError: hasError(
          item.worker_detail.error_columns,
          'staying_period_expiration_date'
        ),
      })
    );
    data.push(
      new Cell({
        value: hyphenToFowardSlash(
          _.defaultTo(item.worker_detail.experience_start_date, '')
        ),
        isError: hasError(
          item.worker_detail.error_columns,
          'experience_start_date'
        ),
      })
    );
    data.push(
      new Cell({
        value: _.isNil(item.worker_detail.blank_months)
          ? ''
          : `${item.worker_detail.blank_months}ヶ月`,
        isError: hasError(item.worker_detail.error_columns, 'blank_months'),
      })
    );
    data.push(
      new Cell({
        value: _.defaultTo(item.worker_detail.education_ja, ''),
        isError: hasError(item.worker_detail.error_columns, 'education_ja'),
      })
    );
    data.push(
      new Cell({
        value: hyphenToFowardSlash(
          _.defaultTo(item.worker_detail.employment_education_date, '')
        ),
        isError: hasError(
          item.worker_detail.error_columns,
          'employment_education_date'
        ),
      })
    );
    data.push(
      new Cell({
        value: _.defaultTo(
          item.worker_detail.ability_improving_education_code_ja,
          ''
        ),
        isError: hasError(
          item.worker_detail.error_columns,
          'ability_improving_education_code_ja'
        ),
      })
    );
    data.push(
      new Cell({
        value: _.defaultTo(
          item.worker_detail.recurrent_protection_education_code_ja,
          ''
        ),
        isError: hasError(
          item.worker_detail.error_columns,
          'recurrent_protection_education_code_ja'
        ),
      })
    );
    data.push(
      new Cell({
        value: hyphenToFowardSlash(
          _.defaultTo(item.worker_detail.employer_in_date, '')
        ),
        isError: hasError(item.worker_detail.error_columns, 'employer_in_date'),
      })
    );
    data.push(
      new Cell({
        value: _.defaultTo(item.worker_detail.postal_code, ''),
        isError: hasError(item.worker_detail.error_columns, 'postal_code'),
      })
    );
    data.push(
      new Cell({
        value: _.defaultTo(item.worker_detail.prefectures, ''),
        isError: hasError(item.worker_detail.error_columns, 'prefectures'),
      })
    );
    data.push(
      new Cell({
        value: _.defaultTo(item.worker_detail.city_name, ''),
        isError: hasError(item.worker_detail.error_columns, 'city_name'),
      })
    );
    data.push(
      new Cell({
        value: _.defaultTo(item.worker_detail.address1, ''),
        isError: hasError(item.worker_detail.error_columns, 'address1'),
      })
    );
    data.push(
      new Cell({
        value: _.defaultTo(item.worker_detail.address2, ''),
        isError: hasError(item.worker_detail.error_columns, 'address2'),
      })
    );
    data.push(
      new Cell({
        value: _.defaultTo(item.worker_detail.tel, ''),
        isError: hasError(item.worker_detail.error_columns, 'tel'),
      })
    );
    data.push(
      new Cell({
        value: _.defaultTo(item.worker_detail.fax, ''),
        isError: hasError(item.worker_detail.error_columns, 'fax'),
      })
    );
    data.push(
      new Cell({
        value: _.defaultTo(item.worker_detail.email, ''),
        isError: hasError(item.worker_detail.error_columns, 'email'),
      })
    );
    result.push(data);
  });

  return result;
};

const hasError = (errorFields, key) => {
  return _.includes(errorFields, key);
};

// 各スクロールバーのサイズはブラウザごとに異なるため、スクロールバーの幅を取得する
export const getScrollbarWidth = () => {
  const outer = document.createElement('div');
  outer.style.visibility = 'hidden';
  outer.style.overflow = 'scroll';
  document.body.appendChild(outer);

  const inner = document.createElement('div');
  outer.appendChild(inner);

  const scrollbarWidth = outer.offsetWidth - inner.offsetWidth;
  document.body.removeChild(outer);

  return scrollbarWidth;
};



// WEBPACK FOOTER //
// ./src/utilities/workersCaptureTableUtil.js